import newsStyle from './news.module.css';

export function News() {
  return (
    <div className={newsStyle.div}>Новости</div>
  );
}
